<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Report Definition
      <div slot="right">
        <b-button type="is-normal import-button" @click="$router.go(-1)"
          >Cancel</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <b-collapse class="validation-panel" animation="slide">
        <div class="card validation-card">
          <div class="card-content">
            <div class="columns">
              <div
                class="column columns no-margin"
                v-if="formData && formData.parent_report_definition_id"
              >
                <div class="column">
                  <b-icon icon="file-chart-outline"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div
                    class="columns validation-text-header"
                    v-if="formData && formData.parent_report_definition_id"
                  >
                    Follow Up Report Type
                    <span
                      @click.prevent="redirectToKDB(formData.report_url)"
                      v-if="formData && formData.parent_report_definition_id"
                    >
                      <b-icon size="is-small" icon="open-in-new"></b-icon>
                    </span>
                  </div>
                  <div class="columns">
                    <p
                      class="no-padding validation-import-comments"
                      v-if="
                        formData &&
                          formData.parent_report_definition_id &&
                          formData.report_type
                      "
                    >
                      {{ formData.report_type }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="chart-box-outline"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    {{
                      formData && formData.parent_report_definition_id
                        ? "Parent Report Definition"
                        : "Report Type"
                    }}
                    <span
                      @click.prevent="
                        redirectToReportDefinition(
                          formData.parent_report_definition_id
                        )
                      "
                      v-if="formData && formData.parent_report_definition_id"
                    >
                      <b-icon size="is-small" icon="open-in-new"></b-icon>
                    </span>
                    <span
                      @click.prevent="redirectToKDB(formData.report_url)"
                      v-else
                    >
                      <b-icon size="is-small" icon="open-in-new"></b-icon>
                    </span>
                  </div>
                  <div class="columns">
                    <p
                      class="no-padding validation-import-comments"
                      v-if="formData && formData.report_type"
                    >
                      {{
                        formData && formData.parent_report_definition_id
                          ? formData.parent_report_type
                          : formData.report_type
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="calendar-start"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div
                    class="columns validation-text-header"
                    v-if="formData && formData.valid_from"
                  >
                    Valid From
                  </div>
                  <div class="columns">
                    <p
                      class="no-padding validation-import-comments"
                      v-if="formData && formData.valid_from"
                    >
                      {{ formData.valid_from }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="calendar-end"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div
                    class="columns validation-text-header"
                    v-if="formData && formData.valid_to"
                  >
                    Valid To
                  </div>
                  <div class="columns">
                    <p
                      class="no-padding validation-import-comments"
                      v-if="formData && formData.valid_to"
                    >
                      {{ formData.valid_to }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData">
                <div class="column">
                  <b-icon icon="calendar-clock"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Last Updated
                  </div>
                  <div class="columns">
                    <p class="no-padding" v-if="formData">
                      {{ formData.updated_at }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData">
                <div class="column">
                  <b-icon icon="account-edit"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Last Updated by
                  </div>
                  <div class="columns">
                    <p class="no-padding">{{ formData.updated_by_name }}</p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="content-save"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Current Status
                  </div>
                  <div class="columns">
                    <p
                      v-if="formData"
                      class="no-padding validation-import-status"
                    >
                      {{ formData.status }}
                      &nbsp;&nbsp;
                      <span
                        v-if="formData.status == 'Rejected'"
                        class="additional-info"
                      >
                        <b-tooltip
                          type="is-primary"
                          :label="formData.comment_for_rejection"
                          multilined
                        >
                          <i class="mdi mdi-information"></i>
                        </b-tooltip>
                      </span>
                    </p>
                    <p v-else class="no-padding validation-import-comments">
                      Unsaved
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </section>
    <section class="section is-main-section no-padding-top" v-if="formData">
      <div class="report-definition-scope">
        <div class="scope-bundle" v-if="formData.country_name">
          <div class="scope">
            <div class="country-with-flag">
              <country-flag
                :country="formData.country_code"
                size="small"
                v-if="formData.country_code"
              />
              <span class="scope-text">{{ formData.country_name }}</span>
            </div>
          </div>
          <hr class="scope-hr" />
        </div>
        <div class="scope-bundle" v-if="formData.scheme_name">
          <div class="scope">
            <span class="scope-text">{{ formData.scheme_name }}</span>
          </div>
          <hr class="scope-hr" />
        </div>
        <div class="scope-bundle" v-if="formData.stream_name">
          <div class="scope">
            <span class="scope-text">{{ formData.stream_name }}</span>
          </div>
          <hr class="scope-hr" />
        </div>
        <ul class="scope-rule-list">
          <li v-for="(value, index) in scopeData" :key="index" class="scope">
            <span v-on:click="showRule(value)"
              ><a href="#">{{ value.name }}</a></span
            >
          </li>
        </ul>
        <hr />
      </div>
      <div class="scope-bundle">
        <h3>Categories</h3>
        <ul class="categories enable-select-text">
          <li
            v-for="(category, index) in categories"
            :key="index"
            class="category"
          >
            <b :title="'ID: ' + category.id">{{ category.name }}</b>
            <ul v-if="category.rules && category.rules.length > 0">
              <hr class="scope-hr" />
              <li
                v-for="(value, index) in category.rules"
                :key="index"
                class="scope rule-list"
              >
                <span class="rule">
                  <b-icon
                    v-if="value.priority === 'low'"
                    icon="chevron-double-down"
                    class="rule-priority-down"
                  />
                  <b-icon
                    v-if="value.priority === 'high'"
                    icon="chevron-double-up"
                    class="rule-priority-up"
                  />
                  <a href="#" @click.prevent.stop="showRule(value)">{{
                    value.name
                  }}</a></span
                >
              </li>
            </ul>
            <hr class="scope-hr" />
            <ul class="sub-categories">
              <li
                v-for="(subCategory, index) in category.sub_categories"
                :key="index"
                class="sub-category"
              >
                <b :title="'ID: ' + subCategory.id">{{ subCategory.name }}</b>
                <hr class="scope-hr" />
                <ul v-if="subCategory.rules">
                  <li
                    v-for="(value, index) in subCategory.rules"
                    :key="index"
                    class="scope rule-list"
                  >
                    <span class="rule">
                      <b-icon
                        v-if="value.priority == 'low'"
                        icon="chevron-double-down"
                        class="rule-priority-down"
                      />
                      <b-icon
                        v-if="value.priority == 'high'"
                        icon="chevron-double-up"
                        class="rule-priority-up"
                      />
                      <a href="#" @click.prevent.stop="showRule(value)">{{
                        value.name
                      }}</a></span
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <br /><br />
    </section>
    <view-rules
      :is-active="isViewModalActive"
      :formData="viewRule"
      @cancel="cancelViewRule"
      :show-edit-button="false"
      :rule-tags="ruleTags"
      @checkReportDef="openReportDefList"
    />
    <view-report-def
      :is-active="isViewReportDefModalActive"
      :formData="viewRule"
      @cancel="cancelViewReportDef"
    />
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import RulesManagerService from "../../services/RulesManagerService";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ViewRules from "@/components/RulesManager/ViewRules.vue";
import ViewReportDef from "@/components/RulesManager/ViewReportDef.vue";
export default {
  name: "ReportDefinition",
  components: {
    HeroBar,
    TitleBar,
    ViewRules,
    ViewReportDef
  },
  mixins: [UtilityMixin],
  props: {
    isViewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      viewRule: {},
      data: [],
      formData: [],
      isDataLoading: false,
      isLoading: false,
      isViewModalActive: false,
      categories: this.$route.params.categories,
      scopeData: this.$route.params.scopeData,
      editObject: this.getClearFormObject(),
      RulesManagerService: new RulesManagerService(),
      ruleTags: [],
      isViewReportDefModalActive: false
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Rules Manager" },
        { url: "/rulesManager/reportDefinitions", name: "Report Definitions" },
        { url: "#", name: "Report Definition" }
      ];
    }
  },
  mounted() {
    this.checkExternalPermission();
    this.getReportDefinitionById();
    this.fetchRuleTags();
  },

  methods: {
    redirectToKDB(url) {
      window.open(url, "_blank");
    },
    redirectToReportDefinition(id) {
      if (!id) return;

      // Get the base URL from the current location
      const baseUrl = window.location.origin;

      // Construct the complete URL manually to ensure it's correct
      const url = `${baseUrl}/rulesManager/reportDefinition/${id}/view`;

      // Open in a new tab with the complete URL
      window.open(url, "_blank");
    },
    openReportDefList() {
      this.isViewReportDefModalActive = true;
    },
    cancelViewReportDef() {
      this.isViewReportDefModalActive = false;
    },
    fetchRuleTags() {
      this.RulesManagerService.getRulesTags().subscribe(response => {
        this.ruleTags = response;
      });
    },
    showRule(value) {
      const tagSelected = this.ruleTags
        .filter(item => (value["tags"] ? value["tags"].includes(item.id) : ""))
        .map(a => a.name)
        .toString();

      value["tags"] = tagSelected == "" ? "NA" : tagSelected;
      this.isViewModalActive = true;
      this.viewRule = value;
    },
    cancelViewRule() {
      this.isViewModalActive = false;
    },
    getReportDefinitionById() {
      this.isLoading = true;
      this.RulesManagerService.getViewReportDefinitionById(
        this.$route.params.id
      ).subscribe(response => {
        this.formData = response;
        this.fetchScopes(response);
        //this.selectedRules = this.formData.rule;
        this.categories = this.formData.categories;
        this.categories.forEach((value, index) => {
          if (value.rules.length > 0 && this.formData.status != "Approved") {
            this.categories[index].rules = value.rules.filter(
              value => value.active
            );
          }
          if (value.sub_categories.length > 0) {
            value.sub_categories.forEach((value2, index2) => {
              if (
                value2.rules.length > 0 &&
                this.formData.status != "Approved"
              ) {
                this.categories[index].sub_categories[
                  index2
                ].rules = value2.rules.filter(value => value.active);
              }
            });
          }
        });
        this.formData.updated_at
          ? (this.formData.updated_at = this.dateToLocalDate(
              this.formData.updated_at
            ))
          : null;
        this.isLoading = false;
      }, this.handleApiError);
    },
    getClearFormObject() {
      this.formData = [];
    },

    redirectToReport() {
      this.formData = [];

      // First try to navigate using Vue Router
      try {
        this.$router.push({
          name: "rulesManager.reportDefinitions"
        });
      } catch (error) {
        // If Vue Router navigation fails, use a direct URL approach
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/rulesManager/reportDefinitions`;
      }
    },

    handleApiError(reason) {
      this.isLoading = false;
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Invalid input";
        }
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.redirectToReport()
      });
    },

    fetchScopes(formData) {
      this.RulesManagerService.getFilterScopeData(formData).subscribe(
        response => {
          this.scopeData = response.results;
        }
      );
    }
  }
};
</script>
